import * as Tone from "tone"
let inst = {};
let getRand = (arr) => arr[Math.floor(Math.random() * arr.length)]

var pianoNotesPool = ["A", "C", "Ds", "Fs"];

let pianoSamples = {};
pianoNotesPool.map((val) => {
    for (var i = 4; i < 6; i++)
        pianoSamples[val.replace(/s/gi, '#') + i] = val + i + 'v6.[mp3|ogg]';
})


var pianoParams = [
    pianoSamples, 
    {
    "attack": 0.02,
    "release": 0.5,
    "baseUrl": "./salamander/"
}]
var xyloParams = [
    {
        'A3': 'A3.[mp3|ogg]',
        'A4': 'A4.[mp3|ogg]',
        'C3': 'C3.[mp3|ogg]',
        'C4': 'C4.[mp3|ogg]',
        'C5': 'C5.[mp3|ogg]',
        'D#3': 'Ds3.[mp3|ogg]',
        'D#4': 'Ds4.[mp3|ogg]',
        'D#5': 'Ds5.[mp3|ogg]',
        'F#3': 'Fs3.[mp3|ogg]',
        'F#4': 'Fs4.[mp3|ogg]',
        'F#5': 'Fs5.[mp3|ogg]',
    }, 
    {
    "attack": 0.01,
    "release": 0.5,
    "baseUrl": "./xylo/"
}]


let delayL = new Tone.PingPongDelay("16n", 0.1)
let delayR = new Tone.PingPongDelay("16n", 0.1)
let delay3 = new Tone.PingPongDelay("16n", 0.1)

delayL.wet.value = 0;
delayR.wet.value = 0;
delay3.wet.value = 0;
let meterL = new Tone.Meter();
let meterR = new Tone.Meter();
let defaultFreq = 20
let filterL = new Tone.Filter(defaultFreq, "highpass", -24);
let filterR = new Tone.Filter(defaultFreq, "highpass", -24);

let pannerL1 = new Tone.Panner(-0.1).toDestination()
let pannerL2 = new Tone.Panner(-0.9).toDestination()
let pannerL3 = new Tone.Panner(-0.5).toDestination()
let pannerR1 = new Tone.Panner(0.9).toDestination()
let pannerR2 = new Tone.Panner(0.7).toDestination()
let pannerR3 = new Tone.Panner(0.6).toDestination()
let synthL = new Tone.Sampler(...xyloParams)
let synthR = new Tone.Sampler(...xyloParams)
synthL.volume.value = -16
synthR.volume.value = -16
synthL.connect(delayL)
synthR.connect(delayR)

delayL.connect(filterL)
delayR.connect(filterR)
filterL.connect(pannerL1)
filterL.connect(pannerL2)
filterL.connect(pannerL3)
filterR.connect(pannerR1)
filterR.connect(pannerR2)
filterR.connect(pannerR3)

delayL.connect(meterL)
delayR.connect(meterR)

Tone.Transport.bpm.value = 60;

inst = {
    delayL,
    delayR,
    filterL,
    filterR,
    synthL,
    synthR,
    meterL,
    meterR,
    defaultFreq,
    ready: 0,
    drone: undefined,
    bell: undefined
}
export default inst
